var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('div',[_c('a',{staticClass:"navLabel",attrs:{"id":"back-btn"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(_vm._s(_vm.$t('labels.go_to_last_page')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }